import { IGetBancoPagamentoDropDownUseCase } from "../../../presentation/useCases/read/get_banco_pagamento_drop_down_use_case";
import { BancoPagamentoDropDown } from "../../models/banco_pagamento_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetBancoPagamentoDropDownUseCase
 */

export class GetBancoPagamentoDropDownUseCase implements IGetBancoPagamentoDropDownUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getBancoPagamentoDropDown(): Promise<BancoPagamentoDropDown[]> {
    return await this.repository.getBancoPagamentoDropDown();
  }
}
